import './sidebar.scss'
import templateUrl from './sidebar.html'

/**
 * Sidebar component.
 *
 * Used by the `sidebar` view of the {@link tmrDefaultAppState `app` state}.
 *
 * @example
 * <tmr-sidebar
 *   logged-user=""
 *   expand-sidebar=""
 *   collapse-sidebar=""
 * ></tmr-sidebar>
 *
 * @type {ngComponent}
 * @prop {User} logged-user
 * @prop {function} expand-sidebar
 * @prop {function} collapse-sidebar
 */
export const tmrSidebar = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrSidebarController',
  bindings: {
    loggedUser: '<',
    expandSidebar: '&',
    collapseSidebar: '&',
  },
}

/**
 * Controller of component {@link tmrSidebar}.
 *
 * @type {ngController}
 */
export class tmrSidebarController {
  static ngType = 'controller'

  constructor(UserStorage) {
    'ngInject'
    Object.assign(this, { UserStorage })
  }

  $onInit() {
    this.showDebugMenu = this.UserStorage.isDebugger()
  }
}
